import { createContext, ReactElement, useContext } from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { usePickerTranslations } from '@mui/x-date-pickers/hooks';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';

interface IPickerDraftActions {
  cancel: () => void;
  accept: () => void;
}

export const PickerDraftActionsContext = createContext<IPickerDraftActions | null>(null);

const PickerDraftActionBar = ({ className }: PickersActionBarProps): ReactElement | null => {
  const actions = useContext(PickerDraftActionsContext);
  const translations = usePickerTranslations();

  if (!actions) return null;

  return (
    <DialogActions className={className}>
      <Button onClick={actions.cancel}>{translations.cancelButtonLabel}</Button>
      <Button onClick={actions.accept}>{translations.okButtonLabel}</Button>
    </DialogActions>
  );
};

export default PickerDraftActionBar;
